import { CheckBox } from "devextreme-react";
import { GroupItem } from "devextreme-react/form";
import { Form, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../redux/localization";
import { CompleteContact } from "../../contact/type";
import { renderInformationItem } from "../../productRequestPage/detail";
import { PendingContacts } from "./type";


const PendingContactsDetail = forwardRef<any, { data: PendingContacts , complete : CompleteContact}>((
    { data }, ref
) => {

    const localize = useSelector(getLocalized);
    
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                label={{
                    text: localize.getString("name"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Surname"}
                label={{
                    text: localize.getString("surname"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Phone"}
                label={{
                    text: localize.getString("phone"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Email"}
                label={{
                    text: localize.getString("email"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Message"}
                label={{
                    text: localize.getString("message"),
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"IsCompleted"}

                label={{
                    text: localize.getString("isComplated"),
                }}
                render={(e: any) => {
                    return <CheckBox
                        value={data.isCompleted}
                        disabled={true}
                    ></CheckBox>
                }}
            >

            </SimpleItem>
        </GroupItem>
    </Form>
})

export default PendingContactsDetail